import { invokeAPRequestWithArgs, requestSuccess, requestError } from '../utils/index';

export const GET = (url, data = {}) =>
	new Promise((resolve, reject) => {
		invokeAPRequestWithArgs({
			url,
			contentType: 'application/json',
			data,
			success: (data) => requestSuccess(data, resolve),
			error: (err) => requestError(err, reject),
		});
	});
export const POST = (url, data = {}) =>
	new Promise((resolve, reject) => {
		invokeAPRequestWithArgs({
			url,
			type: 'POST',
			contentType: 'application/json',
			data: JSON.stringify(data),
			success: (data) => requestSuccess(data, resolve),
			error: (err) => requestError(err, reject),
		});
	});
export const POST_FILE = (url, comment, fileToUpload) =>
	new Promise((resolve, reject) => {
		invokeAPRequestWithArgs({
			url,
			type: 'POST',
			contentType: 'multipart/form-data',
			data: { comment, file: fileToUpload },
			success: (data) => requestSuccess(data, resolve, false),
			error: (err) => requestError(err, reject),
		});
	});
export const PUT = (url, data = {}) =>
	new Promise((resolve, reject) => {
		invokeAPRequestWithArgs({
			url,
			type: 'PUT',
			contentType: 'application/json',
			data: JSON.stringify(data),
			success: (data) => requestSuccess(data, resolve),
			error: (err) => requestError(err, reject),
		});
	});
export const DELETE = (url) =>
	new Promise((resolve, reject) => {
		invokeAPRequestWithArgs({
			url,
			type: 'DELETE',
			contentType: 'application/json',
			success: (data) => requestSuccess(data, resolve, false),
			error: (err) => requestError(err, reject),
		});
	});
